import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { N1EventRow, useN1EventColumns } from "./columns";
import { FilterN1Events, type FilterN1EventsSchema } from "./filter";

const client = "n1";
const table_name = "n1_events";

export function N1EventsTable() {
  const { t } = useTranslation();
  const columns = useN1EventColumns();

  return (
    <Table<N1EventRow, FilterN1EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterN1Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
